<div class="news-slider">
  <div class="content" #slider>
    <ng-container *ngFor="let item of slides; let i = index">
      <div *ngIf="i === current" [@slideInOut] [@.disabled]="!loaded" class="slide">
        <a
          *ngIf="item.type === newsTypes.text"
          [routerLink]="getNewsRoute(item.id)"
        >
          <div class="image">
            <img [src]="item.cover.path" class="desktop">
            <img [src]="item.mobilePicture.path || item.cover.path" class="mobile">
          </div>
          <div class="info">
            <div class="tournament" *ngIf="item.tournaments && item.tournaments.length === 1">
              {{ item.tournaments[0].name }}
            </div>
            <div class="title">{{ item.title }}</div>
          </div>
        </a>
        <iframe
          *ngIf="item.type === newsTypes.video"
          width="100%"
          height="100%"
          [src]="item.videoLink | safe: 'resourceUrl'"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </ng-container>
  </div>
  <div class="navigation">
    <ng-container *ngIf="slides.length > 1">
      <a href="javascript:;" class="previous" (click)="prev()"><mtg-svg-icon icon="icons-arrow-left"></mtg-svg-icon></a>
      <div class="pagination">
        <a
          *ngFor="let _ of slides;let i = index;"
          href="javascript:;"
          [ngClass]="{active: i === current}"
          (click)="select(i)"
        ></a>
      </div>
      <a href="javascript:;" class="next" (click)="next()"><mtg-svg-icon icon="icons-arrow-right"></mtg-svg-icon></a>
    </ng-container>
  </div>
</div>
